// src/utils/endpoints.js
const ENDPOINTS = {
  LOGIN: "https://b.coinsexchange.com/login",
};

export default ENDPOINTS;
